module.exports = __webpack_public_path__ + "img/tratamiento_outline_inactivo.f3b565b4.svg";